import { motion } from "framer-motion";
import { Mail, Linkedin, Facebook, ArrowUpRight } from "lucide-react";
import { reveal } from "@/components/site/motionPresets";

const LINKS = [
  {
    id: "email",
    label: "Email",
    sub: "contactus@onevidariadigital.com",
    href: "mailto:contactus@onevidariadigital.com",
    Icon: Mail,
  },
  {
    id: "linkedin",
    label: "LinkedIn",
    sub: "Follow our company",
    href: "https://www.linkedin.com/company/113574166",
    Icon: Linkedin,
  },
  {
    id: "facebook",
    label: "Facebook",
    sub: "@onevidariadigital",
    href: "https://www.facebook.com/onevidariadigital",
    Icon: Facebook,
  },
];

function recordConnectClick(channel) {
  window.posthog?.capture("connect_click", { section: channel });
}

export default function Connect() {
  return (
    <section
      id="connect"
      data-testid="connect-section"
      aria-label="Contact and collaboration channels"
      className="relative py-28 sm:py-36"
    >
      <div className="mx-auto max-w-5xl px-6 lg:px-10 text-center">
        <motion.h2
          {...reveal({ y: 18, duration: 0.8, margin: undefined })}
          data-testid="connect-heading"
          className="font-serif-display text-4xl font-medium tracking-tight text-cream sm:text-5xl lg:text-6xl"
        >
          Get in touch.
        </motion.h2>

        <motion.p
          {...reveal({ y: 18, duration: 0.8, delay: 0.08, margin: undefined })}
          data-testid="connect-copy"
          className="mt-8 mx-auto max-w-2xl text-base sm:text-lg leading-relaxed text-white/70"
        >
          Email is fastest. We read everything.
        </motion.p>

        <div
          className="mt-16 grid grid-cols-1 sm:grid-cols-3 gap-4 sm:gap-5"
          data-testid="connect-links"
        >
          {LINKS.map(({ id, label, sub, href, Icon }, i) => (
            <motion.a
              key={id}
              href={href}
              target={id === "email" ? undefined : "_blank"}
              rel={id === "email" ? undefined : "noopener noreferrer"}
              onClick={() => recordConnectClick(id)}
              data-testid={`connect-link-${id}`}
              {...reveal({
                y: 16,
                duration: 0.6,
                delay: 0.08 * i,
                margin: "-60px",
              })}
              className="group relative overflow-hidden rounded-xl border border-line bg-surface-1 p-7 text-left transition-colors duration-300 hover:border-[#10B981] hover:bg-surface-2"
            >
              <div className="relative flex items-start justify-between">
                <div className="h-12 w-12 grid place-items-center rounded-md bg-[#10B981]/12 border border-[#10B981]/30 text-[#10B981] group-hover:bg-[#10B981] group-hover:text-[#06231A] transition-colors duration-300">
                  <Icon size={20} strokeWidth={1.5} />
                </div>
                <ArrowUpRight
                  size={16}
                  className="text-white/60 transition-colors duration-300 group-hover:text-[#10B981]"
                />
              </div>
              <div className="relative mt-8">
                <p className="font-display text-2xl text-white">{label}</p>
                <p className="mt-2 text-sm text-white/65 break-all">{sub}</p>
              </div>
            </motion.a>
          ))}
        </div>
      </div>
    </section>
  );
}
